export function getProductLabel(count: number): string {
  const n = Math.abs(count);

  if (n % 10 === 1 && n % 100 !== 11) return 'produkt';

  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) return 'produkty';

  return 'produktov';
}
